module.exports = __webpack_public_path__ + "img/oys-3.a435a178.png";